import { useEffect, useState } from 'react';
import { Button, Snackbar } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * Un onglet ouvert pendant des jours garde l'ancien code (#66). Au retour sur
 * l'onglet, on compare la version du bundle à `/version.json` (écrit au build,
 * servi en no-cache) et on propose de recharger — sans forcer, pour ne pas
 * perdre une saisie en cours.
 */
export default function NewVersionNotice({ current }: { current: string | undefined }) {
  const { t } = useTranslation();
  const [stale, setStale] = useState(false);

  useEffect(() => {
    if (!current) return; // dev et tests : pas de version de build
    const check = async () => {
      if (document.visibilityState !== 'visible') return;
      try {
        const res = await fetch('/version.json', { cache: 'no-store' });
        if (!res.ok) return;
        const { version } = (await res.json()) as { version?: string };
        if (version && version !== current) setStale(true);
      } catch {
        // hors ligne : on réessaiera au prochain retour
      }
    };
    document.addEventListener('visibilitychange', check);
    return () => document.removeEventListener('visibilitychange', check);
  }, [current]);

  return (
    <Snackbar
      open={stale}
      message={t('common.newVersion')}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      action={
        <Button color="secondary" size="small" onClick={() => window.location.reload()}>
          {t('common.reload')}
        </Button>
      }
    />
  );
}
